<div *ngIf="drillDownDataStatus" class="card dashboardTable container-table" #tableContainer1>
    <!-- <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button>
            <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
        </ng-template>
        <ng-template pTemplate="right" class="parent_dialog">
            <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload>
            <button (click)="menu_dialog.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                icon="pi pi-upload" class="p-button-help"></button>

            <p-menu styleClass="prime-slider-override" class="child_dialog" #menu_dialog [popup]="true"
                [model]="appVerificationItems_dialog"></p-menu>
        </ng-template>

    </p-toolbar> -->
    <p-table #miSurvey [value]="drillDownData" [scrollable]="true" scrollHeight="flex" [rows]="10"
        [paginator]="true" [globalFilterFields]="[
    'appid',
    'Level_ID',
    'NextLevelId',
    'UserName',
    'assigneddate', 
    'pendingdays', 
    ]" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <button type="button" pButton pRipple icon="pi pi-file" label="{{'DOWNLOAD'| translate}}" (click)="menu_dialog.toggle($event)" class="mr-2" pTooltip="" tooltipPosition="bottom"></button>

                    <p-menu styleClass="prime-slider-override" class="child_dialog" #menu_dialog [popup]="true"
                        [model]="appVerificationItems_dialog"></p-menu>
                </span>
                <span class="p-input-icon-right">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!-- <th pSortableColumn="userId">{{'USER_ID'| translate}}
                    <p-columnFilter type="text" field="userId" display="menu"></p-columnFilter>
                    <p-sortIcon field="userId"></p-sortIcon>
                </th> -->
                <th pSortableColumn="appid">{{'APP_ID'| translate}}
                    <p-columnFilter type="text" field="appid" display="menu"></p-columnFilter>
                    <p-sortIcon field="appid"></p-sortIcon>
                </th>
                <th pSortableColumn="UserName">{{'USER_NAME'| translate}}
                    <!-- <p-columnFilter type="text" field="UserName" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserName"></p-sortIcon> -->
                </th>
                <th pSortableColumn="NextLevelId">{{'Next User'| translate}}
                    <!-- <p-columnFilter type="text" field="NextLevelId" display="menu"></p-columnFilter>
                    <p-sortIcon field="NextLevelId"></p-sortIcon> -->
                </th>
                <th pSortableColumn="assigneddate">{{'ASSIGN_DATE'| translate}}
                    <!-- <p-columnFilter type="text" field="assigneddate" display="menu"></p-columnFilter>
                    <p-sortIcon field="assigneddate"></p-sortIcon> -->
                </th>
                <!-- <th pSortableColumn="mobile">{{'MOBILE'| translate}}
                    <p-columnFilter type="text" field="mobile" display="menu"></p-columnFilter>
                    <p-sortIcon field="mobile"></p-sortIcon>
                </th> -->
                <th pSortableColumn="pendingdays">{{'PENDING_DAYS'| translate}}
                    <!-- <p-columnFilter type="text" field="pendingdays" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingdays"></p-sortIcon> -->
                </th>
            </tr>
        </ng-template>
        <!-- <p-progressSpinner *ngIf="!drillDownData"></p-progressSpinner> -->
        <ng-template pTemplate="body" let-drillDownData>
            <tr>
                <!-- <td>{{drillDownData.userId}}</td> -->
                <td>{{drillDownData?.appid}}</td>
                <td>{{drillDownData?.UserName}}</td>
                <td>{{drillDownData?.NextLevelId}}</td>
                <td>{{drillDownData?.assigneddate | date:'mediumDate'}}</td>
                <td>{{drillDownData?.pendingdays}}</td>
                <!-- <td>{{drillDownData.mobile}}</td>
                <td *ngIf="!(drillDownData?.pendingApplication > 0)">{{drillDownData?.pendingApplication}}</td>
                <td *ngIf="drillDownData?.pendingApplication > 0"><a class="link_pointer" (click)="showPendingDetailUserWiseDialog(drillDownData)">{{ drillDownData.pendingApplication }}</a></td> -->
            </tr>
        </ng-template>

    </p-table>
</div>


<div *ngIf="displayPendingDetailUserWise" #tableContainer2>
    <app-drill-down-consolidated-userwise-report *ngIf="displayPendingDetailUserWise"
        [drilldownDetails]="drilldownDetails"></app-drill-down-consolidated-userwise-report>
</div>